import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    rootContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        background: '#FFFFFF',
        borderRadius: '24px'
    },
    rightContainer: {
        background: "#053742",
        width: '59%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        // margin: '0 auto',
    },
    leftContainer: {
        borderRadius: "24px 0px 0px 24px",
        background: "#ffffff",
        width: "42%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto"
    },
    brandContainer: {
        display: "flex",
        flexDirection: "row",
        marginBottom: "30px"
    },
    brandTextContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: "36px"
    },
    brandText: {
        fontFamily: "BMWHelvetica",
        fontWeight: 700,
        fontSize: "24px"
    },
    formContainer: {
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        width: '340px',
        border: 'none'
    },
    inputBox: {
        borderRadius: "24px",
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
        border: 'none',
        paddingLeft: '18px',
        width: '340px',
        height: '49px',
        fontFamily: 'Work Sans',
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '21px',
        color: '#14142B',
    },
    buttonContainer: {
        width: '340px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'space-between',
        justifyContent: 'space-between',
        marginTop: '20px',
    },
    wrapper: {
        margin: "1px",
        position: "relative",
    },
    buttonProgress: {
        color: "#053742",
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    globalError: {
        display: "flex",
        flexDirection: "row",
        marginBottom: "30px",
        borderTop: "2px  solid #DB3939",
        borderRadius: '24px',
        padding: "12px 20px",
        width: '340px',
        height: '49px',
    },
})
)